import { render, staticRenderFns } from "./ModalSPEI.vue?vue&type=template&id=8e1d68aa"
import script from "./ModalSPEI.vue?vue&type=script&lang=js"
export * from "./ModalSPEI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports